import { getReportsSentDataForPieChart } from "components/Dashboards/AdministrativeDashboard/utils";
import React from "react";
import { useTranslation } from "react-i18next";
import { TooltipProps } from "recharts";
import LinePieChart from "../LinePieChart/LinePieChart";

const CustomTooltip = ({ active, payload }: TooltipProps<number, string>) => {
  const { t } = useTranslation();
  if (active && payload && payload.length) {
    const percentage = payload[0]?.payload?.percentage;
    const sentAmount = payload[0]?.payload?.amount;
    return (
      <div className="tooltip-container data-box">
        <LinePieChart
          innerRadius={15}
          outerRadius={20}
          data={getReportsSentDataForPieChart(percentage)}
          percent={percentage}
        />
        <div className="column">
          <p className="amount">{sentAmount}</p>
          <p>{t("reports")}</p>
        </div>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
